import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { createReduxEnhancer, init } from '@sentry/react';

import App from './App';
import packageJson from '../package.json';
import './index.css';

import mainReducer from './redux/reducers/MainReducer';
import { userAuthenticationProcess } from './helpers/AuthenticationHelper';

const middleware = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const version = packageJson.version;

const sentryReduxEnhancer = createReduxEnhancer({});

export const store = createStore(
  mainReducer,
  composeEnhancers(applyMiddleware(...middleware), sentryReduxEnhancer),
);

if (process.env.REACT_APP_LOG_IN_SENTRY === 'on') {
  init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    sampleRate: process.env.REACT_APP_SENTRY_SAMPLE_RATE,
    normalizeDepth: process.env.REACT_APP_SENTRY_DEPTH,
    tracesSampleRate: process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE,
    release: version,
  });
}

store.dispatch(userAuthenticationProcess());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
